<script lang="ts">
  import { getPrivacyNoticeCopy } from './privacyCopy';

  export let onAccept: () => void;

  const copy = getPrivacyNoticeCopy();
</script>

<div class="privacy-notice" role="dialog" aria-modal="true" aria-labelledby="privacy-title">
  <div class="privacy-card">
    <h1 id="privacy-title" class="privacy-title">{copy.title}</h1>
    <p class="privacy-intro">{copy.intro}</p>
    <ul class="privacy-bullets">
      {#each copy.bulletPoints as point}
        <li>{point}</li>
      {/each}
    </ul>
    <p class="privacy-disclaimer">{copy.legalDisclaimer}</p>
    <button class="accept-btn" on:click={onAccept} type="button">
      {copy.acceptButtonLabel}
    </button>
  </div>
</div>

<style>
  .privacy-notice {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: var(--ptt-space-4, 16px);
  }
  .privacy-card {
    background: var(--ptt-white, #fff);
    border-radius: var(--ptt-radius-md, 8px);
    padding: var(--ptt-space-6, 32px);
    max-width: 560px;
    width: 100%;
    box-shadow: var(--ptt-shadow-md, 0 4px 12px rgba(0,0,0,0.12));
  }
  .privacy-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ptt-gray-300, #323232);
    margin-bottom: var(--ptt-space-3, 12px);
  }
  .privacy-intro {
    color: var(--ptt-gray-200, #565656);
    margin-bottom: var(--ptt-space-4, 16px);
  }
  .privacy-bullets {
    list-style: disc;
    padding-left: var(--ptt-space-5, 24px);
    margin-bottom: var(--ptt-space-4, 16px);
  }
  .privacy-bullets li {
    color: var(--ptt-gray-200, #565656);
    margin-bottom: var(--ptt-space-2, 8px);
    line-height: 1.5;
  }
  .privacy-disclaimer {
    font-size: 0.875rem;
    color: var(--ptt-gray-100, #7D7D7D);
    font-style: italic;
    margin-bottom: var(--ptt-space-5, 24px);
    padding: var(--ptt-space-3, 12px);
    border-left: 3px solid var(--ptt-yellow-100, #FCCC31);
    background: var(--ptt-yellow-10, #FEF3CF);
  }
  .accept-btn {
    background: var(--ptt-yellow-100, #FCCC31);
    color: var(--ptt-black, #000);
    border: none;
    border-radius: var(--ptt-radius-sm, 4px);
    padding: var(--ptt-space-3, 12px) var(--ptt-space-5, 24px);
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
  }
  .accept-btn:hover {
    background: var(--ptt-yellow-200, #F4B130);
  }
</style>
